import { Component, OnInit } from '@angular/core';
import { UploadFilesService } from '../../services/upload-files.service';

@Component({
  selector: 'app-envio-mail-masivo',
  templateUrl: './envio-mail-masivo.component.html',
  styleUrls: ['./envio-mail-masivo.component.scss']
})
export class EnvioMailMasivoComponent implements OnInit {
  fechaActual:string
  constructor(private uploadFileService:UploadFilesService) { 
    this.fechaActual=this.getFecActual()
  }

  ngOnInit() {
  }

  changeUploadFile(){
    let file:any
    file=document.querySelector("#fileMasivo");
    
    file=file.value.replace(/C:\\fakepath\\/i,'');
    setTimeout(()=>{
      this.uploadFileData()
    },1500)
  }

  openFile(){
    let inputF:any=document.querySelector("#fileMasivo")
    inputF.click()
  }

  uploadFileData(){
 
    var formData = new FormData();
    let fileData:any
    fileData = document.querySelector('#fileMasivo') as HTMLInputElement;
    let plantilla:any=document.querySelector('.mail-masivo')
    
    const fileInfo=fileData.files instanceof FileList
    ? fileData.files[0] : ''
    formData.append("archivo", fileInfo);
    formData.append("plantilla_mensaje", plantilla.innerHTML);

    this.uploadFileService.uploadFileEmailMasivo(formData).subscribe((data:any)=>{
      //console.log(data)
    })
  }

  getFecActual(){
    let hoy = new Date();
    let i=0;
    let fecha = hoy.getDate()+ '/' + ((hoy.getMonth())+1) + '/' + hoy.getFullYear();
    let mes:any=((hoy.getMonth())+1);
    mes=(mes.toString().length==1)?"0"+mes:mes;
    let dia:any=hoy.getDate();
    dia=(dia.toString().length==1)?"0"+dia:dia;
    return hoy.getFullYear()+"-"+mes+"-"+dia
  }
}
